import { render, staticRenderFns } from "./multiselectDropdown.vue?vue&type=template&id=48310c80&scoped=true&"
import script from "./multiselectDropdown.vue?vue&type=script&lang=js&"
export * from "./multiselectDropdown.vue?vue&type=script&lang=js&"
import style0 from "./multiselectDropdown.vue?vue&type=style&index=0&id=48310c80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48310c80",
  null
  
)

export default component.exports